/**
 * Разбор payload JWT — одно объявление на весь фронт.
 *
 * JWT кодируется в **base64url** (RFC 7515): `+` заменён на `-`, `/` на `_`, хвостовые
 * `=` отброшены. Нативный `atob` понимает только обычный base64 и на таком payload
 * бросает `InvalidCharacterError` — токен с «неудобным» набором байт молча читался как
 * невалидный. Здесь алфавит возвращается к base64 и дополняется до кратности четырём.
 */
export function parseJwtPayload(token: string): Record<string, unknown> | null {
    try {
        const parts = token.split(".");
        if (parts.length !== 3) return null;
        const segment = parts[1]!;
        const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
        return JSON.parse(atob(padded)) as Record<string, unknown>;
    } catch {
        return null;
    }
}
